export default {
  familyName: 'Arial',
  fullName: 'Arial',
  postscriptName: 'ArialMT',
  category: 'sans-serif',
  capHeight: 1467,
  ascent: 1854,
  descent: -434,
  lineGap: 67,
  unitsPerEm: 2048,
  xHeight: 1062,
  xWidthAvg: 913,
  subsets: {
    latin: {
      xWidthAvg: 913
    },
    thai: {
      xWidthAvg: 1536
    }
  }
};
